module.exports = __webpack_public_path__ + "img/8.96a5cf6e.jpg";